import { cn } from '@anytag/shared-utils';
import { Button, ButtonProps } from '@anytag/shared-atoms';

interface SplitButtonProps {
  options: (ButtonProps & { isActive?: boolean })[];
  className?: string;
}
export const SplitButton = ({ options, className }: SplitButtonProps) => (
  <div className={cn('flex items-center', className)}>
    {options.map(({ className, isActive, ...restOption }, i) => (
      <Button
        key={i}
        style={{
          ['--btn-icon' as string]: isActive ? 'var(--color-blue-70)' : undefined
        }}
        className={cn(
          'rounded-0 min-w-25 tracking-normal',
          'first-of-type:rounded-r-none',
          'last-of-type:-ml-1px last-of-type:rounded-l-none',
          isActive ? 'bg-active/10text-active z-1 box-border border-active text-active' : 'hover:opacity-70',
          className
        )}
        {...restOption}
      />
    ))}
  </div>
);
